import React, { useId } from 'react';

export function BundlesIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  const clipId = useId();
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d='M8.33403 7.58334C8.33403 7.78225 8.25497 7.97302 8.11432 8.11368C7.97367 8.25433 7.7829 8.33334 7.58398 8.33334H1.58398C1.38508 8.33334 1.19431 8.25433 1.05366 8.11368C0.913001 7.97302 0.833984 7.78225 0.833984 7.58334V1.58334C0.833984 1.38444 0.913001 1.19367 1.05366 1.05301C1.19431 0.91236 1.38508 0.833344 1.58398 0.833344H7.58398C7.7829 0.833344 7.97367 0.91236 8.11432 1.05301C8.25497 1.19367 8.33403 1.38444 8.33403 1.58334V7.58334Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.33403 7.58334C8.33403 7.78225 8.25497 7.97302 8.11432 8.11368C7.97367 8.25433 7.7829 8.33334 7.58398 8.33334H1.58398C1.38508 8.33334 1.19431 8.25433 1.05366 8.11368C0.913001 7.97302 0.833984 7.78225 0.833984 7.58334V1.58334C0.833984 1.38444 0.913001 1.19367 1.05366 1.05301C1.19431 0.91236 1.38508 0.833344 1.58398 0.833344H7.58398C7.7829 0.833344 7.97367 0.91236 8.11432 1.05301C8.25497 1.19367 8.33403 1.38444 8.33403 1.58334V7.58334Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.1641 7.58334C19.1641 7.78225 19.0851 7.97302 18.9444 8.11368C18.8038 8.25433 18.613 8.33334 18.4141 8.33334H12.4141C12.2152 8.33334 12.0244 8.25433 11.8838 8.11368C11.7431 7.97302 11.6641 7.78225 11.6641 7.58334V1.58334C11.6641 1.38444 11.7431 1.19367 11.8838 1.05301C12.0244 0.91236 12.2152 0.833344 12.4141 0.833344H18.4141C18.613 0.833344 18.8038 0.91236 18.9444 1.05301C19.0851 1.19367 19.1641 1.38444 19.1641 1.58334V7.58334Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.1641 7.58334C19.1641 7.78225 19.0851 7.97302 18.9444 8.11368C18.8038 8.25433 18.613 8.33334 18.4141 8.33334H12.4141C12.2152 8.33334 12.0244 8.25433 11.8838 8.11368C11.7431 7.97302 11.6641 7.78225 11.6641 7.58334V1.58334C11.6641 1.38444 11.7431 1.19367 11.8838 1.05301C12.0244 0.91236 12.2152 0.833344 12.4141 0.833344H18.4141C18.613 0.833344 18.8038 0.91236 18.9444 1.05301C19.0851 1.19367 19.1641 1.38444 19.1641 1.58334V7.58334Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.33403 18.4167C8.33403 18.6156 8.25497 18.8063 8.11432 18.947C7.97367 19.0877 7.7829 19.1667 7.58398 19.1667H1.58398C1.38508 19.1667 1.19431 19.0877 1.05366 18.947C0.913001 18.8063 0.833984 18.6156 0.833984 18.4167V12.4167C0.833984 12.2177 0.913001 12.027 1.05366 11.8863C1.19431 11.7457 1.38508 11.6667 1.58398 11.6667H7.58398C7.7829 11.6667 7.97367 11.7457 8.11432 11.8863C8.25497 12.027 8.33403 12.2177 8.33403 12.4167V18.4167Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.33403 18.4167C8.33403 18.6156 8.25497 18.8063 8.11432 18.947C7.97367 19.0877 7.7829 19.1667 7.58398 19.1667H1.58398C1.38508 19.1667 1.19431 19.0877 1.05366 18.947C0.913001 18.8063 0.833984 18.6156 0.833984 18.4167V12.4167C0.833984 12.2177 0.913001 12.027 1.05366 11.8863C1.19431 11.7457 1.38508 11.6667 1.58398 11.6667H7.58398C7.7829 11.6667 7.97367 11.7457 8.11432 11.8863C8.25497 12.027 8.33403 12.2177 8.33403 12.4167V18.4167Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.1641 18.4167C19.1641 18.6156 19.0851 18.8063 18.9444 18.947C18.8038 19.0877 18.613 19.1667 18.4141 19.1667H12.4141C12.2152 19.1667 12.0244 19.0877 11.8838 18.947C11.7431 18.8063 11.6641 18.6156 11.6641 18.4167V12.4167C11.6641 12.2177 11.7431 12.027 11.8838 11.8863C12.0244 11.7457 12.2152 11.6667 12.4141 11.6667H18.4141C18.613 11.6667 18.8038 11.7457 18.9444 11.8863C19.0851 12.027 19.1641 12.2177 19.1641 12.4167V18.4167Z'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.1641 18.4167C19.1641 18.6156 19.0851 18.8063 18.9444 18.947C18.8038 19.0877 18.613 19.1667 18.4141 19.1667H12.4141C12.2152 19.1667 12.0244 19.0877 11.8838 18.947C11.7431 18.8063 11.6641 18.6156 11.6641 18.4167V12.4167C11.6641 12.2177 11.7431 12.027 11.8838 11.8863C12.0244 11.7457 12.2152 11.6667 12.4141 11.6667H18.4141C18.613 11.6667 18.8038 11.7457 18.9444 11.8863C19.0851 12.027 19.1641 12.2177 19.1641 12.4167V18.4167Z'
          stroke='currentColor'
          strokeOpacity='0.2'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
